import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ActionTypes as UIActions } from '../actions/ui';
import { ActionTypes as UploadActions } from '../actions/upload';
var initialState = {
  uploadBtnDisabled: true,
  alertFileSize: false,
  alertFileType: false
};
function uiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case UIActions.SHOW:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.key, true));
    case UIActions.HIDE:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.key, false));
    case UploadActions.CLOSE_ERROR_MESSAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        alertFileSize: false,
        alertFileType: false
      });
    default:
      return state;
  }
}
export default uiReducer;